<template>
    <div class="block-editor assign-owner">
        <section>
            <div class="title">{{ $t("chatbotv2.assignmentMethod") }}</div>
            <a-select v-model="clone.method" class="classic-select">
                <a-select-option value="algorithmic">{{ $t("chatbotv2.algorithmicAssignment") }}</a-select-option>
                <a-select-option value="static">{{ $t("chatbotv2.staticAssignment") }}</a-select-option>
            </a-select>
        </section>

        <section v-if="clone.method === 'static'">
            <div class="title">{{ $t("chatbotv2.agentToAssign") }}</div>
            <a-select v-model="clone.staticUserId" class="classic-select" :placeholder="$t('chatbotv2.selectAgentPlaceholder')" allow-clear>
                <a-select-option :value="'null'">{{ $t("chatbotv2.unownedRemoveOwner") }}</a-select-option>
                <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
            <small>{{ $t("chatbotv2.agentAssignmentHelp") }}</small>
        </section>

        <section v-if="clone.method === 'algorithmic'">
            <div class="title">{{ $t("auto.assignOwnerAlgorithm") }}</div>
            <a-select v-model="clone.algorithm" class="classic-select">
                <a-select-option value="least_contact">{{ $t("chatbotv2.leastContact") }}</a-select-option>
                <a-select-option value="random">{{ $t("auto.assignOwnerRandom") }}</a-select-option>
            </a-select>
        </section>

        <section v-if="clone.method === 'algorithmic'">
            <div class="title">{{ $t("auto.assignOwnerDateRange") }}</div>
            <a-select v-model="clone.dateRange" class="classic-select">
                <a-select-option value="today">{{ $t("auto.assignOwnerToday") }}</a-select-option>
                <a-select-option value="last_7_days">{{ $t("auto.assignOwnerLast7Days") }}</a-select-option>
                <a-select-option value="last_30_days">{{ $t("auto.assignOwnerLast30Days") }}</a-select-option>
            </a-select>
            <small>{{ $t("chatbotv2.agentContactRangeHelp") }}</small>
        </section>
        <section v-if="clone.method === 'algorithmic'">
            <div class="title">{{ $t("chatbotv2.distributeOnlyToOnline") }}</div>
            <a-switch v-model="clone.checkOnlineStatus" />
        </section>

        <section v-if="clone.method === 'algorithmic'">
            <div class="title">{{ $t("chatbotv2.agentsToExclude") }}</div>
            <a-select v-model="clone.excludeUserIds" mode="multiple" class="classic-select">
                <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
            <small>{{ $t("chatbotv2.agentsExcludeHelp") }}</small>
        </section>

        <section v-if="zohoChannelExists">
            <div class="title">{{ $t("chatbotv2.zohoCrmSync") }}</div>
            <a-switch v-model="clone.syncOnZoho" />
            <small>
                {{ $t("chatbotv2.zohoCrmSyncHelp") }}
            </small>
        </section>

        <a-alert
            type="info"
            :message="$t('chatbotv2.assignOwnerVisibilityInfo')"
            show-icon
        />
    </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";

export default {
    name: "AssignOwner",
    props: ["value"],
    data() {
        const clonedValue = _.cloneDeep({
            method: "algorithmic",
            ...this.value
        });
        if (clonedValue.staticUserId === null) {
            clonedValue.staticUserId = 'null';
        }
        return {
            clone: clonedValue,
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            zohoChannelExists: (state) => !!state.channel.channels.some((channel) => channel.type === "zoho"),
        }),
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                const emitValue = _.cloneDeep(newValue);

                if (emitValue.staticUserId === 'null') {
                    emitValue.staticUserId = null;
                }

                this.$emit("input", emitValue);
            },
        },
    },
    created() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.assign-owner {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    .classic-select {
        width: 100%;
    }

    small {
        color: #777;
    }
}
</style>
